<template>
  <div>
    <!-- 基本信息 -->
    <el-card class="mb-4">
      <template #header>
        <div class="flex items-center">
          <el-icon class="mr-2"><InfoFilled /></el-icon>
          <span>{{ $t('admin.user.detail.basicInfo') }}</span>
        </div>
      </template>

      <el-descriptions :column="2" border>
        <el-descriptions-item v-for="item in basicInfo" :key="item.label" :label="item.label">
          {{ item.value }}
        </el-descriptions-item>
      </el-descriptions>
    </el-card>

    <!-- 联系方式 -->
    <el-card class="mb-4">
      <template #header>
        <div class="flex items-center">
          <el-icon class="mr-2"><Phone /></el-icon>
          <span>{{ $t('admin.user.detail.contactInfo') }}</span>
        </div>
      </template>

      <el-descriptions :column="2" border>
        <el-descriptions-item :label="$t('admin.user.detail.labels.phone')">
          {{ target?.phone || '-' }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('admin.user.detail.labels.email')">
          {{ target?.email || '-' }}
        </el-descriptions-item>
      </el-descriptions>
    </el-card>

    <!-- 角色信息 -->
    <el-card>
      <template #header>
        <div class="flex items-center">
          <el-icon class="mr-2"><Key /></el-icon>
          <span>{{ $t('admin.user.detail.roleInfo') }}</span>
        </div>
      </template>

      <div class="flex flex-wrap gap-4">
        <el-tag v-for="role in target?.roleTexts" :key="role" type="primary">
          {{ role }}
        </el-tag>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { InfoFilled, Key, Phone } from '@element-plus/icons-vue'

const props = defineProps({
  target: {
    type: Object,
    default: null,
  },
})

// 基本信息描述列表数据
const { t } = useI18n()

const basicInfo = computed(() => {
  if (!props.target) return []

  return [
    {
      label: t('admin.user.detail.labels.userName'),
      value: props.target.name,
    },
    {
      label: t('admin.user.detail.labels.userId'),
      value: props.target.id,
    },
    {
      label: t('admin.user.detail.labels.createdAt'),
      value: props.target.created_at,
    },
    {
      label: t('admin.user.detail.labels.updatedAt'),
      value: props.target.updated_at,
    },
  ]
})
</script>
